module.exports = __webpack_public_path__ + "media/images/emblems/AireLaVille-coat_of_arms-369a13ffd22dfc03363b0e348039de07.svg";